/**
 * CONFIG — Single source of truth for all app-wide configuration.
 */

export const CONFIG = {
  API_BASE_URL:      'https://fastfood-api.emran-h5124.workers.dev/api',
  STORAGE_KEY:       'SAFRAN_APP_STATE',
  IMAGE_CACHE_KEY:   'SAFRAN_IMG_CACHE',
  OTP_EXPIRY_MS:     10 * 60 * 1000,
  OTP_COUNTDOWN_SEC: 60,

  // ── Navigation guards ────────────────────────────────────────────────────
  // Pages that require a non-empty cart to enter
  REQUIRES_CART: ['invoice', 'otp', 'checkout'],
  // Pages that require authentication to enter
  REQUIRES_AUTH: ['checkout'],
  // Pages that require a completed order to enter
  REQUIRES_ORDER: ['success'],
  // Pages blocked when restaurant is closed
  BLOCKED_WHEN_CLOSED: ['checkout'],

  PAYMENT_GATEWAY: {
    provider:    'zarinpal',
    merchantId:  'YOUR_MERCHANT_ID',
    callbackUrl: `${window.location.origin}/#payment-result`,
    sandbox:     true,
  },

  SMS_PROVIDER: {
    provider:     'kavenegar',
    apiKey:       'YOUR_API_KEY',
    templateName: 'verify',
  },

  // ── Map providers ────────────────────────────────────────────────────────
  // Switch 'provider' to 'neshan' or 'balad' and fill the key
  MAP: {
    provider:   'neshan',           // 'neshan' | 'balad' | 'leaflet'
    apiKey:     'YOUR_MAP_API_KEY', // Neshan / Balad API key
    defaultLat: 35.6892,            // Default map center (Tehran)
    defaultLng: 51.3890,
    defaultZoom: 14,
  },
};
